exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3f40f978] button{opacity:1!important}[data-v-3f40f978] .col-form-label{font-size:19px}[data-v-3f40f978] .custom-control-label{font-size:16px}", ""]);

// exports
